<div class="max-w-8xl mx-auto p-2 md:p-8 min-h-screen relative">
    <p-toast></p-toast>
    
    <!-- Loading Overlay -->
    <div *ngIf="isDataLoading" class="absolute inset-0 bg-white bg-opacity-90 z-50 flex items-center justify-center">
        <div class="text-center">
            <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p class="text-lg font-medium text-gray-700">Loading company settings...</p>

        </div>
    </div>
    
    <!-- Header Section -->
    <div class="text-start flex justify-between items-center mb-8">
        <div>
            <p class="font-semibold mb-2 text-3xl">Settings</p>
            <p class="text-gray-600 text-lg m-0">Manage your subscription and personal preferences.</p>
        </div>
        <div class="flex gap-2 w-full justify-end">
          <p-button 
              label="Save all" 
              icon="pi pi-save"
              [loading]="isLoading"
              [disabled]="isLoading"
              (click)="saveAllSettings()"
              />
        </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="bg-white p-6 rounded-xl border border-gray-200">
            <p class="font-semibold mb-2 text-xl flex items-center gap-2"><svg width="20" height="21"
                    viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M20 10.5C20 10.5352 20 10.5703 20 10.6055C19.9844 12.0312 18.6875 13 17.2617 13H13.4375C12.4023 13 11.5625 13.8398 11.5625 14.875C11.5625 15.0078 11.5781 15.1367 11.6016 15.2617C11.6836 15.6602 11.8555 16.043 12.0234 16.4297C12.2617 16.9688 12.4961 17.5039 12.4961 18.0703C12.4961 19.3125 11.6523 20.4414 10.4102 20.4922C10.2734 20.4961 10.1367 20.5 9.99609 20.5C4.47656 20.5 0 16.0234 0 10.5C0 4.97656 4.47656 0.5 10 0.5C15.5234 0.5 20 4.97656 20 10.5ZM5 11.75C5 11.4185 4.8683 11.1005 4.63388 10.8661C4.39946 10.6317 4.08152 10.5 3.75 10.5C3.41848 10.5 3.10054 10.6317 2.86612 10.8661C2.6317 11.1005 2.5 11.4185 2.5 11.75C2.5 12.0815 2.6317 12.3995 2.86612 12.6339C3.10054 12.8683 3.41848 13 3.75 13C4.08152 13 4.39946 12.8683 4.63388 12.6339C4.8683 12.3995 5 12.0815 5 11.75ZM5 8C5.33152 8 5.64946 7.8683 5.88388 7.63388C6.1183 7.39946 6.25 7.08152 6.25 6.75C6.25 6.41848 6.1183 6.10054 5.88388 5.86612C5.64946 5.6317 5.33152 5.5 5 5.5C4.66848 5.5 4.35054 5.6317 4.11612 5.86612C3.8817 6.10054 3.75 6.41848 3.75 6.75C3.75 7.08152 3.8817 7.39946 4.11612 7.63388C4.35054 7.8683 4.66848 8 5 8ZM11.25 4.25C11.25 3.91848 11.1183 3.60054 10.8839 3.36612C10.6495 3.1317 10.3315 3 10 3C9.66848 3 9.35054 3.1317 9.11612 3.36612C8.8817 3.60054 8.75 3.91848 8.75 4.25C8.75 4.58152 8.8817 4.89946 9.11612 5.13388C9.35054 5.3683 9.66848 5.5 10 5.5C10.3315 5.5 10.6495 5.3683 10.8839 5.13388C11.1183 4.89946 11.25 4.58152 11.25 4.25ZM15 8C15.3315 8 15.6495 7.8683 15.8839 7.63388C16.1183 7.39946 16.25 7.08152 16.25 6.75C16.25 6.41848 16.1183 6.10054 15.8839 5.86612C15.6495 5.6317 15.3315 5.5 15 5.5C14.6685 5.5 14.3505 5.6317 14.1161 5.86612C13.8817 6.10054 13.75 6.41848 13.75 6.75C13.75 7.08152 13.8817 7.39946 14.1161 7.63388C14.3505 7.8683 14.6685 8 15 8Z"
                        fill="#6B7280" />
                </svg>
                Branding</p>
            <div class="flex flex-wrap lg:flex-row flex-col items-start gap-5 lg:gap-12 mt-5">
                <div>
                    <p class="text-gray-600 text-sm">Company Logo</p>
                    <div class="flex items-center gap-2 mt-2">
                        <!-- image preview div -->
                        <div class="w-14 h-14 bg-gray-200 rounded-xl flex items-center justify-center overflow-hidden company-logo-preview"
                            (click)="companyLogoUrl ? viewLogo() : null" [class.cursor-pointer]="companyLogoUrl">
                            <img *ngIf="companyLogoUrl" [src]="companyLogoUrl" alt="Company Logo" i18n-alt
                            class="w-16 h-16 object-contain rounded-lg border border-gray-200 p-1">
                            <svg *ngIf="!companyLogoUrl" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM13.96 12.29L11.21 15.83L9.25 13.47L6.5 17H17.5L13.96 12.29Z"
                                    fill="#9CA3AF" />
                            </svg>
                            <div *ngIf="companyLogoUrl" class="logo-hover-overlay">
                                View
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <p class="text-gray-600 text-xs change-logo-text" (click)="openImageUploadDialog()">Change
                            </p>
                        </div>
                    </div>
                </div>
                <div>
                    <p class="text-gray-600 text-sm">Company Name</p>
                    <div class="card flex justify-center mt-2">
                        <input type="text" pInputText [(ngModel)]="companyName" class="lg:min-w-[300px] w-full" />
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white p-6 rounded-xl border border-gray-200">
            <p class="font-semibold mb-2 flex items-center gap-2 text-xl"> <svg width="15" height="21"
                    viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_131_3864)">
                        <g clip-path="url(#clip1_131_3864)">
                            <path
                                d="M2.5 0.5C1.12109 0.5 0 1.62109 0 3V18C0 19.3789 1.12109 20.5 2.5 20.5H12.5C13.8789 20.5 15 19.3789 15 18V6.75H10C9.30859 6.75 8.75 6.19141 8.75 5.5V0.5H2.5ZM10 0.5V5.5H15L10 0.5ZM3.125 3H5.625C5.96875 3 6.25 3.28125 6.25 3.625C6.25 3.96875 5.96875 4.25 5.625 4.25H3.125C2.78125 4.25 2.5 3.96875 2.5 3.625C2.5 3.28125 2.78125 3 3.125 3ZM3.125 5.5H5.625C5.96875 5.5 6.25 5.78125 6.25 6.125C6.25 6.46875 5.96875 6.75 5.625 6.75H3.125C2.78125 6.75 2.5 6.46875 2.5 6.125C2.5 5.78125 2.78125 5.5 3.125 5.5ZM5.24219 15.4141C5.00391 16.207 4.27344 16.75 3.44531 16.75H3.125C2.78125 16.75 2.5 16.4688 2.5 16.125C2.5 15.7812 2.78125 15.5 3.125 15.5H3.44531C3.72266 15.5 3.96484 15.3203 4.04297 15.0547L4.625 13.1211C4.75781 12.6797 5.16406 12.375 5.625 12.375C6.08594 12.375 6.49219 12.6758 6.625 13.1211L7.07812 14.6289C7.36719 14.3867 7.73438 14.25 8.125 14.25C8.74609 14.25 9.3125 14.6016 9.58984 15.1562L9.76172 15.5H11.875C12.2188 15.5 12.5 15.7812 12.5 16.125C12.5 16.4688 12.2188 16.75 11.875 16.75H9.375C9.13672 16.75 8.92188 16.6172 8.81641 16.4062L8.47266 15.7148C8.40625 15.582 8.27344 15.5 8.12891 15.5C7.98438 15.5 7.84766 15.582 7.78516 15.7148L7.44141 16.4062C7.32812 16.6367 7.08203 16.7734 6.82812 16.75C6.57422 16.7266 6.35547 16.5508 6.28516 16.3086L5.625 14.1328L5.24219 15.4141Z"
                                fill="#6B7280" />
                        </g>
                    </g>
                    <defs>
                        <clipPath id="clip0_131_3864">
                            <rect width="15" height="20" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                        <clipPath id="clip1_131_3864">
                            <path d="M0 0.5H15V20.5H0V0.5Z" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                Legal Documents</p>
            <div class="flex items-center justify-between mb-5 mt-5">
                <div class="legal-document-item">
                    <div class="document-info">
                        <p *ngIf="hasTermsConditions()" class="document-name" (click)="viewLegalDocument('terms')">
                            Terms & Conditions.pdf
                        </p>
                        <p *ngIf="!hasTermsConditions()" class="no-document">
                            No Terms & Conditions document
                        </p>
                    </div>
                    <div class="document-actions">
                        <p class="action-button update" (click)="openLegalDocDialog('terms')">Update</p>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-between">
                <div class="legal-document-item">
                    <div class="document-info">
                        <p *ngIf="hasPrivacyPolicy()" class="document-name" (click)="viewLegalDocument('privacy')">
                            Privacy Policy.pdf
                        </p>
                        <p *ngIf="!hasPrivacyPolicy()" class="no-document">
                            No Privacy Policy document
                        </p>
                    </div>
                    <div class="document-actions">
                        <p class="action-button update" (click)="openLegalDocDialog('privacy')">Update</p>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="bg-white p-6 rounded-xl border border-gray-200 mt-9">
        <div class=" flex flex-row items-center gap-2 mb-3"><svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10.5C20 10.5352 20 10.5703 20 10.6055C19.9844 12.0312 18.6875 13 17.2617 13H13.4375C12.4023 13 11.5625 13.8398 11.5625 14.875C11.5625 15.0078 11.5781 15.1367 11.6016 15.2617C11.6836 15.6602 11.8555 16.043 12.0234 16.4297C12.2617 16.9688 12.4961 17.5039 12.4961 18.0703C12.4961 19.3125 11.6523 20.4414 10.4102 20.4922C10.2734 20.4961 10.1367 20.5 9.99609 20.5C4.47656 20.5 0 16.0234 0 10.5C0 4.97656 4.47656 0.5 10 0.5C15.5234 0.5 20 4.97656 20 10.5ZM5 11.75C5 11.4185 4.8683 11.1005 4.63388 10.8661C4.39946 10.6317 4.08152 10.5 3.75 10.5C3.41848 10.5 3.10054 10.6317 2.86612 10.8661C2.6317 11.1005 2.5 11.4185 2.5 11.75C2.5 12.0815 2.6317 12.3995 2.86612 12.6339C3.10054 12.8683 3.41848 13 3.75 13C4.08152 13 4.39946 12.8683 4.63388 12.6339C4.8683 12.3995 5 12.0815 5 11.75ZM5 8C5.33152 8 5.64946 7.8683 5.88388 7.63388C6.1183 7.39946 6.25 7.08152 6.25 6.75C6.25 6.41848 6.1183 6.10054 5.88388 5.86612C5.64946 5.6317 5.33152 5.5 5 5.5C4.66848 5.5 4.35054 5.6317 4.11612 5.86612C3.8817 6.10054 3.75 6.41848 3.75 6.75C3.75 7.08152 3.8817 7.39946 4.11612 7.63388C4.35054 7.8683 4.66848 8 5 8ZM11.25 4.25C11.25 3.91848 11.1183 3.60054 10.8839 3.36612C10.6495 3.1317 10.3315 3 10 3C9.66848 3 9.35054 3.1317 9.11612 3.36612C8.8817 3.60054 8.75 3.91848 8.75 4.25C8.75 4.58152 8.8817 4.89946 9.11612 5.13388C9.35054 5.3683 9.66848 5.5 10 5.5C10.3315 5.5 10.6495 5.3683 10.8839 5.13388C11.1183 4.89946 11.25 4.58152 11.25 4.25ZM15 8C15.3315 8 15.6495 7.8683 15.8839 7.63388C16.1183 7.39946 16.25 7.08152 16.25 6.75C16.25 6.41848 16.1183 6.10054 15.8839 5.86612C15.6495 5.6317 15.3315 5.5 15 5.5C14.6685 5.5 14.3505 5.6317 14.1161 5.86612C13.8817 6.10054 13.75 6.41848 13.75 6.75C13.75 7.08152 13.8817 7.39946 14.1161 7.63388C14.3505 7.8683 14.6685 8 15 8Z"
                    fill="#6B7280" />
            </svg>
            <p class="font-semibold text-xl">Subscription</p>
        </div>
        <div class="flex lg:flex-row flex-col items-start gap-4 w-full">
            <div class="flex-1 w-full">
                <p class="text-gray-600 text-sm mb-3">Industries</p>
                <div class="card flex justify-center mt-2 gap-3 mb-3">
                    <input type="text" pInputText [(ngModel)]="newIndustry" placeholder="Add new industry" i18n-placeholder
                        class="w-full px-0 py-0 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
                        (keypress)="onIndustryKeyPress($event)" />
                    <p-button appGlobalLoadingDisable label="Add" severity="secondary" (click)="addIndustry()" />
                </div>
                <div class="flex flex-wrap gap-2 industry-region-tags">
                    <div *ngFor="let industry of industries" class="tag">
                        <span class="tag-text">{{ industry }}</span>
                        <button class="remove-button" (click)="removeIndustry(industry)" i18n-aria-label aria-label="Remove industry">×</button>
                    </div>
                </div>
            </div>
            <div class="flex-1 w-full">
                <p class="text-gray-600 text-sm mb-3">Operational Regions</p>
                <div class="card flex justify-center mt-2 gap-3 mb-3">
                    <p-select [(ngModel)]="selectedRegion" [options]="countries" optionLabel="name" [filter]="true"
                        filterBy="name" [showClear]="true" placeholder="Select a Country" i18n-placeholder
                        (onChange)="onRegionChange($event)" (onSelect)="onRegionSelect($event)"
                        class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100">
                    </p-select>
                    <p-button label="Add" severity="secondary" [disabled]="!selectedRegion"
                        (click)="addSelectedRegion()">
                    </p-button>
                </div>
                <div class="flex flex-wrap gap-2 industry-region-tags">
                    <div *ngFor="let region of operationalRegions" class="tag">
                        <span class="tag-text">{{ region }}</span>
                        <button class="remove-button" (click)="removeRegion(region)" i18n-aria-label aria-label="Remove region">×</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex lg:flex-row flex-col items-start gap-4 w-full mt-8">
            <div class="flex-1 w-full">
                <p class="font-semibold mb-2 text-lg">Standard Reservation Settings</p>
                <p class="text-gray-600 text-sm mb-3 flex items-center gap-2">
                    Reservation Durations
                    <i class="pi pi-info-circle text-gray-400 cursor-pointer" 
                       [pTooltip]="'Used for pre-contract holds only. Not linked to contract period.'" 
                       tooltipPosition="right"></i>
                </p>
                <div class="card flex justify-center mt-2 gap-3 mb-3">
                    <input type="number" pInputText [(ngModel)]="newReservationDuration" placeholder="Enter number of months (e.g., 6)" i18n-placeholder
                        class="w-full px-0 py-0 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
                        (keypress)="onReservationDurationKeyPress($event)" />
                    <p-button appGlobalLoadingDisable label="Add" severity="secondary" (click)="addReservationDuration()" />
                </div>
                <div class="flex flex-wrap gap-2 industry-region-tags mb-3">
                    <div *ngFor="let reservationDuration of reservationDurationsList" class="tag">
                        <span class="tag-text">{{ reservationDuration }}</span>
                        <button class="remove-button" (click)="removeReservationDuration(reservationDuration)">×</button>
                    </div>
                </div>
                <p class="text-gray-600 text-sm mb-2">Default Duration</p>
                <p-select [(ngModel)]="selectedContractDuration" [options]="getReservationDurationOptions()" optionLabel="label"
                    optionValue="value" placeholder="Select default reservation duration" i18n-placeholder />
            </div>

            <div class="flex-1 w-full">
                <p class="font-semibold mb-2 text-lg">Standard Contract Settings</p>
                <p class="text-gray-600 text-sm mb-3 flex items-center gap-2">
                    Contract Durations
                    <i class="pi pi-info-circle text-gray-400 cursor-pointer" 
                       [pTooltip]="'Defines active agreement length.'" 
                       tooltipPosition="right"></i>
                </p>
                <div class="card flex justify-center mt-2 gap-3 mb-3">
                    <input type="number" pInputText [(ngModel)]="newContractDuration" placeholder="Enter number of months (e.g., 6)" i18n-placeholder
                        class="w-full px-0 py-0 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
                        (keypress)="onContractDurationKeyPress($event)" />
                    <p-button appGlobalLoadingDisable label="Add" severity="secondary" (click)="addContractDuration()" />
                </div>
                <div class="flex flex-wrap gap-2 industry-region-tags">
                    <div *ngFor="let contractDuration of contractDurationsList" class="tag">
                        <span class="tag-text">{{ contractDuration }}</span>
                        <button class="remove-button" (click)="removeContractDuration(contractDuration)" i18n-aria-label aria-label="Remove contract duration">×</button>
                    </div>
                </div>
            </div>


            
        </div>

       

        

    </div>

    <div class="bg-white p-6 rounded-xl border border-gray-200 mt-9">
        <p class="font-semibold mb-2 text-xl flex items-center gap-2"><svg width="18" height="21" viewBox="0 0 18 21"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 10.5C10.0761 10.5 11.3479 9.97322 12.2855 9.03553C13.2232 8.09785 13.75 6.82608 13.75 5.5C13.75 4.17392 13.2232 2.90215 12.2855 1.96447C11.3479 1.02678 10.0761 0.5 8.75 0.5C7.42392 0.5 6.15215 1.02678 5.21447 1.96447C4.27678 2.90215 3.75 4.17392 3.75 5.5C3.75 6.82608 4.27678 8.09785 5.21447 9.03553C6.15215 9.97322 7.42392 10.5 8.75 10.5ZM6.96484 12.375C3.11719 12.375 0 15.4922 0 19.3398C0 19.9805 0.519531 20.5 1.16016 20.5H16.3398C16.9805 20.5 17.5 19.9805 17.5 19.3398C17.5 15.4922 14.3828 12.375 10.5352 12.375H6.96484Z"
                    fill="#6B7280" />
            </svg>

            Languages
        </p>


        <div class="mt-5">
            <p class="text-gray-600 text-sm mb-2">Default Language</p>
            <p-select [(ngModel)]="selectedLanguage" [options]="languages" optionLabel="label" optionValue="value"
                placeholder="Select default language" i18n-placeholder />
        </div>

    </div>

    <!-- Image Upload Dialog -->
    <p-dialog [(visible)]="showImageUploadDialog"
        [header]="hasExistingLogo() ? 'Replace Company Logo' : 'Upload Company Logo'" [modal]="true"
        [style]="{width: '500px','margin-left': '10px','margin-right': '10px'}" [closable]="true" (onHide)="closeImageUploadDialog()" class="image-upload-dialog">

        <div class="flex flex-col gap-4">
             <!-- Image preview -->
             <div *ngIf="imagePreview" class="mb-4 file-preview">
                <h5 i18n>Preview</h5>
                <div class="flex justify-center items-center gap-4">
                    <div class="w-full h-full">
                        <img [src]="imagePreview" alt="Preview" i18n-alt class="object-contain border rounded" />
                    </div>
                </div>
            </div>
            <!-- File Upload -->
            <div class="mb-4 p-4 border-2 border-dashed rounded-lg text-center drag-drop-area"
                [class]="dragOver ? 'border-blue-500 bg-blue-50 drag-over' : 'border-gray-300'"
                [class.loading]="isUploading" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">

                <input type="file" accept="image/*" (change)="onFileUpload($event)" class="hidden"
                    [disabled]="isUploading" id="file-input-logo" />

                <div class="flex flex-col items-center justify-center py-4">
                    <svg class="mb-2" width="38" height="27" viewBox="0 0 38 27" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.6875 26.875C4.0293 26.875 0.25 23.0957 0.25 18.4375C0.25 14.7578 2.60547 11.6289 5.88672 10.4746C5.88086 10.3164 5.875 10.1582 5.875 10C5.875 4.82031 10.0703 0.625 15.25 0.625C18.7246 0.625 21.7539 2.51172 23.377 5.32422C24.2676 4.72656 25.3457 4.375 26.5 4.375C29.6055 4.375 32.125 6.89453 32.125 10C32.125 10.7148 31.9902 11.3945 31.75 12.0273C35.1719 12.7188 37.75 15.748 37.75 19.375C37.75 23.5176 34.3926 26.875 30.25 26.875H8.6875ZM13.3164 14.1602C12.7656 14.7109 12.7656 15.6016 13.3164 16.1465C13.8672 16.6914 14.7578 16.6973 15.3027 16.1465L17.5879 13.8613V21.7188C17.5879 22.498 18.2148 23.125 18.9941 23.125C19.7734 23.125 20.4004 22.498 20.4004 21.7188V13.8613L22.6855 16.1465C23.2363 16.6973 24.127 16.6973 24.6719 16.1465C25.2168 15.5957 25.2227 14.7051 24.6719 14.1602L19.9844 9.47266C19.4336 8.92188 18.543 8.92188 17.998 9.47266L13.3105 14.1602H13.3164Z"
                            fill="#9CA3AF" />
                    </svg>
                    <label for="file-input-logo" class="cursor-pointer text-blue-600 hover:text-blue-800 font-medium"
                        [class.opacity-50]="isUploading" [class.cursor-not-allowed]="isUploading">
                        {{ isUploading ? 'Uploading...' : 'Click to upload or drag and drop' }}
                    </label>
                    <p class="text-sm text-gray-500 mt-2">
                        image/* (MAX. 1MB)
                    </p>
                </div>
            </div>

           

            <!-- Loading indicator -->
            <div *ngIf="isUploading" class="mb-4">
                <div class="flex justify-center items-center gap-2">
                    <i class="pi pi-spin pi-spinner text-blue-600"></i>
                    <span class="text-blue-600">Uploading image...</span>
                </div>
            </div>

            <!-- Upload Button -->
            <div class="flex justify-end gap-3">
                <p-button appGlobalLoadingDisable label="Cancel" severity="secondary" (click)="cancelUpload()">
                </p-button>
                <p-button [label]="isUploading ? 'Uploading...' : 'Upload'"
                    [icon]="isUploading ? 'pi pi-spin pi-spinner' : 'pi pi-upload'"
                    [disabled]="!selectedFile || isUploading" (click)="uploadImage()">
                </p-button>
            </div>
        </div>
    </p-dialog>

    <!-- Confirmation Dialog -->
    <p-confirmDialog></p-confirmDialog>

    <!-- Toast Messages -->
    <p-toast></p-toast>

    <!-- Legal Document Upload Dialog -->
    <p-dialog [(visible)]="showLegalDocDialog"
        [header]="legalDocType === 'terms' ? 'Upload Terms & Conditions' : 'Upload Privacy Policy'" [modal]="true"
        [style]="{width: '500px','margin-left': '10px','margin-right': '10px'}" [closable]="true" (onHide)="closeLegalDocDialog()" class="image-upload-dialog">

        <div class="flex flex-col gap-4">
             <!-- File Preview -->
             <div *ngIf="selectedLegalFile" class="mb-4 file-preview">
                <h5 i18n>Selected File</h5>
                <div class="flex justify-center items-center gap-4">
                    <div class="w-full text-center">
                        <p class="text-sm font-medium text-gray-700">{{ selectedLegalFile.name }}</p>
                        <p class="text-xs text-gray-500">{{ formatFileSize(selectedLegalFile.size) }}</p>
                    </div>
                </div>
            </div>
            <!-- File Upload -->
            <div class="mb-4 p-4 border-2 border-dashed rounded-lg text-center drag-drop-area"
                [class]="dragOver ? 'border-blue-500 bg-blue-50 drag-over' : 'border-gray-300'"
                [class.loading]="isLegalDocUploading" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)" >

                <input type="file" accept=".pdf" (change)="onLegalDocFileUpload($event)" class="hidden"
                    [disabled]="isLegalDocUploading" id="file-input-legal-doc" />

                <div class="flex flex-col items-center justify-center py-4">
                    <svg class="mb-2" width="38" height="27" viewBox="0 0 38 27" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.6875 26.875C4.0293 26.875 0.25 23.0957 0.25 18.4375C0.25 14.7578 2.60547 11.6289 5.88672 10.4746C5.88086 10.3164 5.875 10.1582 5.875 10C5.875 4.82031 10.0703 0.625 15.25 0.625C18.7246 0.625 21.7539 2.51172 23.377 5.32422C24.2676 4.72656 25.3457 4.375 26.5 4.375C29.6055 4.375 32.125 6.89453 32.125 10C32.125 10.7148 31.9902 11.3945 31.75 12.0273C35.1719 12.7188 37.75 15.748 37.75 19.375C37.75 23.5176 34.3926 26.875 30.25 26.875H8.6875ZM13.3164 14.1602C12.7656 14.7109 12.7656 15.6016 13.3164 16.1465C13.8672 16.6914 14.7578 16.6973 15.3027 16.1465L17.5879 13.8613V21.7188C17.5879 22.498 18.2148 23.125 18.9941 23.125C19.7734 23.125 20.4004 22.498 20.4004 21.7188V13.8613L22.6855 16.1465C23.2363 16.6973 24.127 16.6973 24.6719 16.1465C25.2168 15.5957 25.2227 14.7051 24.6719 14.1602L19.9844 9.47266C19.4336 8.92188 18.543 8.92188 17.998 9.47266L13.3105 14.1602H13.3164Z"
                            fill="#9CA3AF" />
                    </svg>
                    <label for="file-input-legal-doc"
                        class="cursor-pointer text-blue-600 hover:text-blue-800 font-medium"
                        [class.opacity-50]="isLegalDocUploading" [class.cursor-not-allowed]="isLegalDocUploading">
                        {{ isLegalDocUploading ? 'Uploading...' : 'Click to upload or drag and drop' }}
                    </label>
                    <p class="text-sm text-gray-500 mt-2">
                        PDF files only (MAX. 5MB)
                    </p>
                </div>
            </div>

           

            <!-- Loading indicator -->
            <div *ngIf="isLegalDocUploading" class="mb-4">
                <div class="flex justify-center items-center gap-2">
                    <i class="pi pi-spin pi-spinner text-blue-600"></i>
                    <span class="text-blue-600">Uploading document...</span>
                </div>
            </div>

            <!-- Upload Button -->
            <div class="flex justify-end gap-3">
                <p-button appGlobalLoadingDisable label="Cancel" severity="secondary" (click)="cancelLegalDocUpload()">
                </p-button>
                <p-button [label]="isLegalDocUploading ? 'Uploading...' : 'Upload'"
                    [icon]="isLegalDocUploading ? 'pi pi-spin pi-spinner' : 'pi pi-upload'"
                    [disabled]="!selectedLegalFile || isLegalDocUploading" (click)="uploadLegalDocument()">
                </p-button>
            </div>
        </div>
    </p-dialog>
</div>